export default "__VITE_ASSET__6e231310__"